module.exports = __webpack_public_path__ + "media/contact/ContactUs-d8eccf4d.jpg";